import React from "react";
import clsx from "clsx";
import { Button } from "@material-ui/core";

const ReportQueueControls = ({ exportFormat, setExportFormat, formatList, onSubmit, classes, disabled  }) => (
  <div>
    <div className={clsx("dxrd-right-panel-header dxd-text-primary", classes.queueSectionTitle)}>Queue Option</div>
    <div className="dx-layout-manager dx-field">
      <div className={clsx("dx-field-label", classes.fortmatFieldLabel)}>Format of Report</div>
      <div className="dx-field-value">
        <select
          className={clsx("dx-dropdowneditor dx-widget dx-selectbox", classes.formatSelectBox)}
          value={exportFormat}
          onChange={(ev) => setExportFormat(Number(ev.target.value))}
        >
          {formatList.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    </div>
    <div>
      <Button
        className={clsx("submitBtn", classes.btnControl)}
        variant="contained"
        color="primary"
        onClick={onSubmit}
        disabled={disabled}
      >
        Submit to Queue
      </Button>
    </div>
  </div>
);

export default ReportQueueControls;
